var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',[_vm._v(_vm._s(_vm.leftStr))]),_c('span',{style:({color: _vm.activeColor})},[_vm._v(_vm._s(_vm.emphasizeStr))]),_c('span',[_vm._v(_vm._s(_vm.rightStr))])])}
var staticRenderFns = []

export { render, staticRenderFns }